import { overload } from "../../../shared/src/codecs/types/overload";
import { required } from "../../../shared/src/codecs/types/required";
import { string } from "../../../shared/src/codecs/types/string";
import { array as codecArray } from "../../../shared/src/codecs/types/array";
import { array } from "fp-ts";
import { pipe } from "fp-ts/lib/function";

export const RecipientsFullLegalNames = overload(
    string(),
    required({
        recipient_users: codecArray(
            required({
                legal_first_legal_name: string(),
                legal_middle_legal_name: string(),
                legal_last_legal_name: string(),
            }),
        ),
        recipient_introducer_account_holder_name: string(),
    }),
    ({recipient_users, recipient_introducer_account_holder_name}) =>
        recipient_users.length === 0 && recipient_introducer_account_holder_name !== ""
            ? recipient_introducer_account_holder_name
            : pipe(
                recipient_users,
                array.map((user) =>
                    pipe(
                        [
                            ...(user.legal_first_legal_name ? [user.legal_first_legal_name] : []),
                            ...(user.legal_middle_legal_name ? [user.legal_middle_legal_name] : []),
                            ...(user.legal_last_legal_name ? [user.legal_last_legal_name] : []),
                        ],
                        (a) => a.length === 0
                            ? "Legal name not given"
                            : a.join(" "),
                    )
                ),
                (a) => a.length === 0
                    ? "No recipients set"
                    : a.join(" & "),
            )
);
